/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillItemVo } from './BillItemVo';
import {
    BillItemVoFromJSON,
    BillItemVoFromJSONTyped,
    BillItemVoToJSON,
    BillItemVoToJSONTyped,
} from './BillItemVo';

/**
 * 
 * @export
 * @interface PaymentItemVo
 */
export interface PaymentItemVo {
    /**
     * ID
     * @type {number}
     * @memberof PaymentItemVo
     */
    id?: number;
    /**
     * 支付单编号
     * @type {string}
     * @memberof PaymentItemVo
     */
    paymentCode?: string;
    /**
     * 账单ID列表
     * @type {Array<number>}
     * @memberof PaymentItemVo
     */
    billIds?: Array<number>;
    /**
     * 用户ID
     * @type {number}
     * @memberof PaymentItemVo
     */
    userId?: number;
    /**
     * 用户名
     * @type {string}
     * @memberof PaymentItemVo
     */
    userName?: string;
    /**
     * 用户账号
     * @type {string}
     * @memberof PaymentItemVo
     */
    account?: string;
    /**
     * 积分支付
     * @type {number}
     * @memberof PaymentItemVo
     */
    pointsPay?: number;
    /**
     * 钱包支付
     * @type {number}
     * @memberof PaymentItemVo
     */
    walletPay?: number;
    /**
     * 赠送金支付金额
     * @type {number}
     * @memberof PaymentItemVo
     */
    bonusPay?: number;
    /**
     * 钱包支付（中国钱包），根据关联账单类型判定；非中国账单时为0
     * @type {number}
     * @memberof PaymentItemVo
     */
    chinaWalletPay?: number;
    /**
     * 钱包支付（韩国钱包），根据关联账单类型判定；非韩国账单时为0
     * @type {number}
     * @memberof PaymentItemVo
     */
    koreaWalletPay?: number;
    /**
     * 支付类型：1-储蓄卡，2-信用卡，3-预存款支付
     * @type {number}
     * @memberof PaymentItemVo
     */
    payType?: number;
    /**
     * 卡号
     * @type {string}
     * @memberof PaymentItemVo
     */
    cardNumber?: string;
    /**
     * 卡支付金额
     * @type {number}
     * @memberof PaymentItemVo
     */
    cardPay?: number;
    /**
     * 货币代码
     * @type {string}
     * @memberof PaymentItemVo
     */
    currencyCode?: string;
    /**
     * 申请日期
     * @type {string}
     * @memberof PaymentItemVo
     */
    applyDate?: string;
    /**
     * 备注
     * @type {string}
     * @memberof PaymentItemVo
     */
    remark?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof PaymentItemVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof PaymentItemVo
     */
    updateTime?: string;
    /**
     * 优惠券抵扣总金额（所有bill的couponAmount求和）
     * @type {number}
     * @memberof PaymentItemVo
     */
    totalCouponAmount?: number;
    /**
     * 实际支付金额 = 卡支付 + 钱包支付 + 信用卡手续费
     * @type {number}
     * @memberof PaymentItemVo
     */
    actualPayAmount?: number;
    /**
     * 信用卡支付手续费
     * @type {number}
     * @memberof PaymentItemVo
     */
    creditCardPaymentFee?: number;
    /**
     * 持卡人姓名
     * @type {string}
     * @memberof PaymentItemVo
     */
    cardHolderName?: string;
    /**
     * 信用卡支付hash_code
     * @type {string}
     * @memberof PaymentItemVo
     */
    creditTransactionHashCode?: string;
    /**
     * 关联的账单列表
     * @type {Array<BillItemVo>}
     * @memberof PaymentItemVo
     */
    billList?: Array<BillItemVo>;
}

/**
 * Check if a given object implements the PaymentItemVo interface.
 */
export function instanceOfPaymentItemVo(value: object): value is PaymentItemVo {
    return true;
}

export function PaymentItemVoFromJSON(json: any): PaymentItemVo {
    return PaymentItemVoFromJSONTyped(json, false);
}

export function PaymentItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'paymentCode': json['paymentCode'] == null ? undefined : json['paymentCode'],
        'billIds': json['billIds'] == null ? undefined : json['billIds'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'account': json['account'] == null ? undefined : json['account'],
        'pointsPay': json['pointsPay'] == null ? undefined : json['pointsPay'],
        'walletPay': json['walletPay'] == null ? undefined : json['walletPay'],
        'bonusPay': json['bonusPay'] == null ? undefined : json['bonusPay'],
        'chinaWalletPay': json['chinaWalletPay'] == null ? undefined : json['chinaWalletPay'],
        'koreaWalletPay': json['koreaWalletPay'] == null ? undefined : json['koreaWalletPay'],
        'payType': json['payType'] == null ? undefined : json['payType'],
        'cardNumber': json['cardNumber'] == null ? undefined : json['cardNumber'],
        'cardPay': json['cardPay'] == null ? undefined : json['cardPay'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'applyDate': json['applyDate'] == null ? undefined : json['applyDate'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
        'totalCouponAmount': json['totalCouponAmount'] == null ? undefined : json['totalCouponAmount'],
        'actualPayAmount': json['actualPayAmount'] == null ? undefined : json['actualPayAmount'],
        'creditCardPaymentFee': json['creditCardPaymentFee'] == null ? undefined : json['creditCardPaymentFee'],
        'cardHolderName': json['cardHolderName'] == null ? undefined : json['cardHolderName'],
        'creditTransactionHashCode': json['creditTransactionHashCode'] == null ? undefined : json['creditTransactionHashCode'],
        'billList': json['billList'] == null ? undefined : ((json['billList'] as Array<any>).map(BillItemVoFromJSON)),
    };
}

export function PaymentItemVoToJSON(json: any): PaymentItemVo {
    return PaymentItemVoToJSONTyped(json, false);
}

export function PaymentItemVoToJSONTyped(value?: PaymentItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'paymentCode': value['paymentCode'],
        'billIds': value['billIds'],
        'userId': value['userId'],
        'userName': value['userName'],
        'account': value['account'],
        'pointsPay': value['pointsPay'],
        'walletPay': value['walletPay'],
        'bonusPay': value['bonusPay'],
        'chinaWalletPay': value['chinaWalletPay'],
        'koreaWalletPay': value['koreaWalletPay'],
        'payType': value['payType'],
        'cardNumber': value['cardNumber'],
        'cardPay': value['cardPay'],
        'currencyCode': value['currencyCode'],
        'applyDate': value['applyDate'],
        'remark': value['remark'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
        'totalCouponAmount': value['totalCouponAmount'],
        'actualPayAmount': value['actualPayAmount'],
        'creditCardPaymentFee': value['creditCardPaymentFee'],
        'cardHolderName': value['cardHolderName'],
        'creditTransactionHashCode': value['creditTransactionHashCode'],
        'billList': value['billList'] == null ? undefined : ((value['billList'] as Array<any>).map(BillItemVoToJSON)),
    };
}

